<template>
  <div class="page page_video_detail" v-if="detail != null">
    <img class="video_detail_thumb" :src="imageUrl + detail.thumb" />
    <van-tabs
      class="video_detail_tab"
      v-model="type"
      line-width=".7rem"
      scrollspy
      sticky
    >
      <van-tab title="简介" name="describe">
        <div class="video_title">{{ detail.title }}</div>
        <!-- <div class="video_describe">
                    {{ detail.describe }}
                </div> -->
        <div class="video_describe" v-html="detail.describe"></div>
      </van-tab>
      <van-tab title="课程" name="live_videos_chapter">
        <div class="page_video_title">课程</div>
        <div class="video_chapters">
          <div
            v-for="(item, key) in detail.live_videos_chapter"
            :key="key"
            class="video_chapter clearfix"
            @click="goPlayVideo(item)"
          >
            <div
              class="video_status f-l"
              v-if="is_charge == 1 && detail.is_buy == 0"
            >
              <span class="sk" v-if="item.times && item.times != 0">试看</span>
              <img
                :src="publicPath + 'statics/images/lock.png'"
                class="locked"
                alt=""
                v-if="showLock(item)"
              />
            </div>
            <div class="video_tu f-r">
              <img :src="imageUrl + item.thumb" />
            </div>
            <div class="video_content">
              <h3 class="video_title">{{ item.title }}</h3>
              <p class="video_desc">{{ item.describe }}</p>
            </div>
          </div>
        </div>
      </van-tab>
      <!-- <van-tab title="推荐" name="live"></van-tab> -->
    </van-tabs>
    <!-- 视频评论 -->
    <div class="page_iteminfo content">
      <div class="comment">
        <div class="title">视频评论</div>
        <div class="comment_none" v-if="!videoComments">
          暂无评论，把你想说的评论出来吧～
        </div>
        <div class="con" v-for="item in videoComments" :key="item.id">
          <div class="con_top clearfix" v-if="item.userdata">
            <div class="f-l thumb">
              <img
                :src="
                  item.userdata.thumb
                    ? $publicData.withHttpStart(item.userdata.thumb)
                      ? item.userdata.thumb
                      : imageUrl + item.userdata.thumb
                    : $publicData.defaultTouxiang
                "
                alt=""
                class="thumb"
              />
            </div>
            <div class="f-l con_top_r">
              <span class="user_name">{{
                item.userdata.nickname
                  ? item.userdata.nickname
                  : $publicData.formatPhone(item.userdata.username)
              }}</span>
              <span class="time">{{ item.created_at }}</span>
            </div>
          </div>
          <div class="con_nr">
            <div class="yiji_txt">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 评论按钮 -->
    <div
      class="pay_wrap"
      v-if="is_charge == 0 || (is_charge == 1 && detail.is_buy == 1)"
    >
      <div class="pinglun" @click="toComment">评论</div>
    </div>
    <!-- 付费 -->
    <div
      class="pay_wrap"
      v-if="is_charge == 1 && detail.is_buy == 0"
      @click="toPay"
    >
      <div class="pay_btn">{{ '¥' + prices }} 直接上课</div>
    </div>
  </div>
</template>

<script>
import router from '../../../.././router';
import { LOGOUT, LOGIN } from '../../../.././vuex/mutation_types';
import PageSearch from '../../../component/search/Index.vue';
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
  data() {
    return {
      richImageUrl: this.$publicData.richTextImage,
      imageUrl: this.$publicData.uploadImage,
      detail: null,
      token: '',
      type: 'describe',
      is_charge: this.$route.query.is_charge, // 视频是否需要付费 0免费 1付费
      prices: this.$route.query.prices, // 视频金额
      publicPath: process.env.BASE_URL,
      videoComments: [], // 视频评论
    };
  },
  computed: {
    showLock() {
      return (item) => {
        /**
         * 这个item是当前选中的视频 里面包含times is_charge
         * this.detail中包含 is_buy
         */
        // 如果已经购买了 则不显示锁
        if (this.detail && this.detail.is_buy == 1) {
          return false;
        }
        // 如果未购买 则判断是否需要付费 如果需要付费 则不显示锁
        if (this.detail && this.detail.is_buy == 0) {
          if (item.is_charge == 0 || item.times > 0) {
            return false;
          }

          // 如果需要付费 或者观看时长为0 则显示锁
          if (item.is_charge == 1 && item.times == 0) {
            return true;
          }
        }
        return true;
      };
    },
  },
  created() {
    var that = this;
    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
      var params = {
        data: {
          naviTitle: '视频详情',
          rightStyle: 'share',
        },
      };
      this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {});
      //获取用户信息
      var memberParams = {
        data: {
          notCallLogin: 1,
        },
      };
      this.$bridge.callhandler(
        'sdjy://member/memberInfo',
        memberParams,
        (data) => {
          if (data.code == 200) {
            this.token = data.result.token;
          } else {
            this.token = '';
          }
          this.getDetail();
        }
      );
      //注册方法，客户端重新进入页面刷新数据
      this.$bridge.registerhandler(
        'sdjy://common/refreshPage',
        (data, responseCallback) => {
          // alert(JSON.stringify(data));
          this.getDetail();
          responseCallback(data);
        }
      );
      //注册方法，右侧点击分享
      this.$bridge.registerhandler(
        'sdjy://common/rightButtonAction',
        (data, responseCallback) => {
          // alert(JSON.stringify(data));
          console.log('sdjy://common/rightButtonAction');
          const url = location.href.split('#')[0];
          var params = {
            data: {
              title: that.detail.title
                ? that.detail.title
                : that.$publicData.shareDefaultTitleA,
              detail: that.detail.describe_new ? that.detail.describe_new : '',
              url: url,
              platFormType: '',
              image: that.detail.thumb
                ? that.$publicData.domain + that.detail.thumb
                : that.$publicData.domain + that.$publicData.shareDefaultIcon,
            },
          };
          this.$bridge.callhandler('sdjy://public/share', params, (data) => {});
        }
      );
    } else {
      this.token = this.$store.getters.token;
      this.getDetail();
    }
  },
  watch: {
    'window.scroll': function (n, o) {
      console.log(n);
    },
  },
  mounted() {
    console.log('111111111111');
    this.getDetail();
  },
  methods: {
    // 获取视频详情
    getDetail() {
      var that = this;
      var params = {
        id: this.$route.query.id,
      };
      if (this.token) {
        params.token = this.token;
      }
      this.$api.living.livevideoDetail(params).then((res) => {
        if (res.code == 200) {
          // 处理富文本
          let info = res.result.info;
          info.describe = info.describe.replace(
            /(<img [^>]*src=['"])([^'"]+)([^>]*)/g,
            function (match, $1, $2, $3) {
              if (/^http/.test($2)) {
                return $1 + $2 + $3;
              } else {
                return $1 + that.richImageUrl + $2 + $3;
              }
            }
          );
          this.detail = info;
          console.log('this.detail', this.detail);
          this.videoComments = res.result.comment;
          this.getShareData();
          // 设置title
          window.document.title = this.detail.title;
        }
      });
    },
    // 去播放视频
    goPlayVideo(item) {
      /**
       * is_charge 1付费,0免费; is_buy 1已购买过,0未购买
       * 如果detail.is_buy == 1 则直接放行观看 所以要判断的前提条件是detail.is_buy == 0
       * 如果item.is_charge == 1 则不支持试看 需要购买
       * 如果item.times == 0 则试看结束 需要购买
       * */
      /**
       * 如果用户已购买 则直接观看
       * 如果用户未购买 则需要判断是否免费
       * 如果不免费 则判断是否有时长 有则观看 否则block
       * =================================================
       * 代码的意思是 如果用户没有购买 则进入逻辑判断是否可以观看
       * 如果当前视频是免费的（is_charge==0）则可以观看
       * 如果当前视频是收费的且没有观看时长 则block
       *
       * */
      if (this.detail.is_buy == 0) {
        if (item.is_charge == 1 && item.times == 0) {
          
          return this.$toast('此视频不支持试看,需要购买');
        }
      }
      this.$router.push({
        path: '/video/play',
        query: {
          id: item.id,
          is_buy: this.detail.is_buy,
          is_charge: this.is_charge,
        },
      });
    },
    // 获取分享参数 -- 用于配微信分享
    getShareData() {
      const url = location.href.split('#')[0];
      this.$api.index
        .commonShare({
          url: url,
        })
        .then((res) => {
          if (res.code == 200) {
            var data = res.result;
            this.shareConfig = data;
            console.log('this.shareConfig', this.shareConfig);
            console.log('this.$route', this.$route);
            this.shareFun();
          }
        });
    },
    // 分享
    shareFun() {
      var that = this;
      // console.log('11111111111111')
      wx.config({
        debug: that.shareConfig.debug,
        beta: that.shareConfig.beta,
        jsApiList: that.shareConfig.jsApiList,
        appId: that.shareConfig.appId,
        nonceStr: that.shareConfig.nonceStr, // 随机串
        timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
        signature: that.shareConfig.signature, // 签名
      });
      // console.log('222222222222')
      // console.log('that.livingDetail+1111',that.livingDetail)
      // 分享
      wx.ready(function () {
        const url = location.href.split('#')[0];
        console.log('url', url);
        console.log('that.detail', that.detail);
        var shareData = {
          title: that.detail.title
            ? that.detail.title
            : that.$publicData.shareDefaultTitleA, // 分享标题
          desc: that.detail.describe_new ? that.detail.describe_new : '', // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.detail.thumb
            ? that.imageUrl + that.detail.thumb
            : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
            // alert('成功')
            // console.log('success')
          },
          cancel: function (e) {
            // console.log('e',e)
            // 用户取消分享后执行的回调函数
          },
        };

        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
      });
    },
    // 创建视频订单并跳转到支付页
    toPay() {
      var that = this;
      if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
        var memberParams = {
          data: {},
        };
        this.$bridge.callhandler(
          'sdjy://member/memberInfo',
          memberParams,
          (data) => {
            if (data.code == 200) {
              that.token = data.result.token;
              var params = {
                token: that.token,
                video_id: that.$route.query.id,
              };
              that.$api.living.createVideoOrder(params).then((res) => {
                if (res.code == 200) {
                  var order_num = res.result.order_num;
                  var params2 = {
                    data: {
                      url:
                        this.$publicData.clientUrl +
                        '/yuekan/pay?orderId=' +
                        order_num +
                        '&price=' +
                        this.prices +
                        '&type=video',
                    },
                  };
                  this.$bridge.callhandler(
                    'sdjy://public/openNewWebView',
                    params2,
                    (data) => {}
                  );
                }
              });
            }
          }
        );
      } else {
        // 验证是否登录
        if (!this.$store.getters.token) {
          localStorage.setItem('redirect', this.$router.currentRoute.fullPath);
          this.$router.push({
            path: '/login',
            // query: {
            //     redirect: this.$router.currentRoute.fullPath
            // }
          });
          return;
        }
        var params = {
          token: this.token,
          video_id: this.$route.query.id,
        };
        this.$api.living.createVideoOrder(params).then((res) => {
          if (res.code == 200) {
            var order_num = res.result.order_num;

            this.$router.push({
              path: '/yuekan/pay',
              query: {
                orderId: order_num,
                price: this.prices,
                type: 'video',
              },
            });
          }
        });
      }
    },
    // 视频评论
    toComment() {
      var that = this;
      if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
        var params = {
          data: {
            url:
              that.$publicData.clientUrl +
              '/video/comment?id=' +
              that.detail.id,
          },
        };
        that.$bridge.callhandler(
          'sdjy://public/openNewWebView',
          params,
          (data) => {}
        );
      } else {
        that.$router.push({
          path: '/video/comment',
          query: {
            id: that.detail.id, // 视频id
          },
        });
      }
    },
  },
};
</script>

<style lang="postcss" scoped></style>
